import React, { useEffect, useState, useMemo } from 'react';
import { Button, Modal, ModalHeader, ModalBody } from 'reactstrap';
import $ from 'jquery';
import { useNavigate, useLocation } from 'react-router-dom';
import Table from './common/Table';
const common = require('../utils/Common');

const SystemConfig = () => {
    let navigate = useNavigate();
    const [allConfig, setAllConfig] = useState([]);
    const [editConfig, setEditConfig] = useState({key: "", value: "", id: ""});
    const [modal, setModal] = useState(false);
    const [userRights, setUserRights] = useState({view: false, edit: false, delete: false, create: false});
    const toggle = () => setModal(!modal);
    const [totalRecords, setTotalRecords] = useState(0);
    
    

	useEffect(() => {
        checkAccess();
	}, []);

    const checkAccess = async () => {
        let rights = await common.checkAccessRights(window.location.pathname);
        if (!rights.view) {
          alert("Access Denied");
          navigate("/");
          return;
        } else {
            setUserRights(rights); 
            if (!localStorage.getItem('admin_token')) {
                navigate('/login');
            }
            crudSystemConfig(0, 'read');
        }
    }

    const addNewConfig = () => {
        toggle();
    }

    const crudSystemConfig = async (id, action) => {
        let data = {
            'id': id,
            'action': action
        }
        if (action == 'create' || action == 'update') {
            data.key = $('#key').val().replace(/(\r\n|\n|\r)/gm, "");
            data.value = $('#value').val().replaceAll(/(\r\n|\n|\r)/gm, "");
        }
        let response = await common.apiRequest('post', '/admin/crud-system-config', data);
        if (response.data.code == 'success') {
            if (action == "read") {
                setAllConfig(response.data.data);
            } else {
                alert(response.data.message);
                if (action != "delete") {
                    toggle();
                }
                crudSystemConfig(0, 'read');
            }
        } else {
            alert(response.data.error);
        }
    }

    const editSystemConfig = (config) => {
        setEditConfig({
            key: config.key,
            value: JSON.stringify(config.value, null, 2),
            id: config._id
        });
        toggle();
    }

    const systemConfigColumns = [
    {
        header: 'Key',
        accessor: 'key'
    },
    {
        header: 'Value',
        accessor: 'value',
        render: (row) => JSON.stringify(row.value),
    },
    {
        header: 'Action',
        accessor: 'action', // Placeholder, actual rendering handled below
        render: (row) => (
        <div>
            { userRights.edit && <button
            className='btn btn-warning btn-sm me-2'
            onClick={() => editSystemConfig(row)}
            >
            Edit
            </button> }
            { userRights.delete && <button
            className='btn btn-danger btn-sm'
            onClick={() => crudSystemConfig(row._id, 'delete')}
            >
            Delete
            </button> }
        </div>
        ),
    },
    ];

    return (
        <>
        <div className='col-md-12'>
            <div className='row'>
                <div className='col-md-6'>
                    <h1>All Configs</h1>
                </div>
                <div className='col-md-6'>
                { userRights.create && <button className='btn btn-primary btn-sm float-right mr-3 mb-5' onClick={addNewConfig}>Add New Config</button>}
                </div>
            </div>
        </div>
                                <div className="ag-theme-quartz" style={{ height: 600, width: '100%' }}>
                                    <Table
                                        columns={systemConfigColumns}
                                        data={allConfig}
                                        totalRecords={totalRecords}
                                        pageSize={10}
                                    />
                                </div>
        <Modal isOpen={modal} toggle={toggle} size="lg">
            <ModalHeader toggle={toggle}>Add Config</ModalHeader>
            <ModalBody>
                <div className='row'>
                    <div className='col-md-2'>
                        <label>Key</label>
                    </div>
                    <div className='col-md-10'>
                        <input type='text' className='form-control' id="key" defaultValue={editConfig.key}/>
                    </div>
                </div>
                <div className='row mt-3'>
                    <div className='col-md-2'>
                        <label>Value</label>
                    </div>
                    <div className='col-md-10'>
                        <textarea id="value" className='form-control' defaultValue={editConfig.value} rows="20"></textarea>
                    </div>
                </div>
                <div className='row mt-3'>
                    <div className='col-md-2'></div>
                    <div className='col-md-10'>
                        <button className='btn btn-primary btn-sm' onClick={() => crudSystemConfig(editConfig.id ? editConfig.id: 0, editConfig.id ? 'update' : 'create')}>Submit</button>
                    </div>
                </div>
            </ModalBody>
        </Modal>
        </>
    )
}

export default SystemConfig;